import React, { useContext } from 'react'
import { Redirect } from 'react-router-dom'
import AuthGuard from './AuthGuard'
import { UserContext } from '../context/userContext'
import { hasPermission, getRolebyUserData } from '../services/permissions'
import { ACTIONS } from '../utils/constants'

// Mismas acciones que filtran los botones en pages/admin/pages/menu/index.js:
// si el rol no tiene ninguna de estas, no tiene sentido que vea el panel admin.
const ADMIN_MODULE_ACTIONS = [
  ACTIONS.ADMINISTRATOR_MODULE.VIEW_ADMINISTRATOR_MODULE,
  ACTIONS.AUCTIONEER_MODULE.VIEW_AUCTIONEER_MODULE,
  ACTIONS.USER_CONTROL_MODULE.VIEW_USER_CONTROL_MODULE,
  ACTIONS.ROOM_OFFER_MODULE.VIEW_ROOM_OFFER_MODULE,
  ACTIONS.ROOM_MODULE.VIEW_ROOM_MODULE,
  ACTIONS.ROBIN_HOOD_MODULE.VIEW_ROBIN_HOOD_MODULE,
  ACTIONS.USER_ENTRY_MODULE.USER_ENTRY_MODULE,
]

function RoleCheck({ action, children }) {
  const { userData } = useContext(UserContext)
  const role = getRolebyUserData(userData || {})

  if (!hasPermission(action, role)) {
    return <Redirect to="/auctionList" />
  }
  return children
}

function AnyAdminRoleCheck({ children }) {
  const { userData } = useContext(UserContext)
  const role = getRolebyUserData(userData || {})
  const hasAnyAdminAccess = ADMIN_MODULE_ACTIONS.some((action) => hasPermission(action, role))

  if (!hasAnyAdminAccess) {
    return <Redirect to="/auctionList" />
  }
  return children
}

// Guard para rutas de administración: exige sesión válida (reutiliza AuthGuard)
// y además el permiso puntual de `action`, usando el mismo mapa de roles que
// ya filtra los botones del menú admin (src/services/permissions.js), para no
// tener dos fuentes de verdad distintas sobre quién puede ver cada módulo.
//
// Uso en routes.js:
//   guard: createAdminGuard(ACTIONS.ADMINISTRATOR_MODULE.VIEW_ADMINISTRATOR_MODULE)
export default function createAdminGuard(action) {
  return function AdminGuard({ children }) {
    return (
      <AuthGuard>
        <RoleCheck action={action}>{children}</RoleCheck>
      </AuthGuard>
    )
  }
}

// Guard para el panel/menú de administración (sin una acción puntual): exige
// sesión válida y que el rol tenga acceso a al menos un módulo admin, para
// que un cliente no llegue a ver el panel aunque salga casi vacío.
export function createAdminMenuGuard() {
  return function AdminMenuGuard({ children }) {
    return (
      <AuthGuard>
        <AnyAdminRoleCheck>{children}</AnyAdminRoleCheck>
      </AuthGuard>
    )
  }
}
